import * as React from 'react'

const SvgCloseIcon = ({
  stroke = 'white',
  width = '12',
  height = '12',
  className = '',
  fill = 'none',
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    stroke={stroke}
  >
    <path
      d="M11 1L1 11M1 1L11 11"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgCloseIcon
